import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Select } from 'components/fields'
import { Button } from 'components/misc'
import { Title } from 'components/layout'
import { form } from 'helpers/decorators'
import { addMoreValidation } from 'models/assessors'

@form({
  form: 'assessor-invite-form',
  initialProps: 'data',
  validate: addMoreValidation
})
class AssessorInvite extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    onAddMore: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    awardUnits: PropTypes.array
  }

  state = {
    isLoading: null
  }

  render() {
    const { handleSubmit, submitting, invalid, awardUnits } = this.props

    return (
      <form
        onSubmit={handleSubmit(fields => this.props.onAddMore(null, fields))}
      >
        <Title h2 intlKey="moduleTitle.invite_assessor">
          Invite assessor
        </Title>
        <div className="row">
          <div className="col-xs-6">
            <Select
              label="Award unit"
              intlKey="label.award_unit"
              options={awardUnits}
              name="organizationId"
              searchable
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              secondary
              intlKey="button.close"
              onClick={() => this.props.modal(null)}
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              intlKey="button.invite"
              disabled={invalid}
              isLoading={submitting}
            >
              Invite
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default AssessorInvite
